<template lang="html">
    <div>
        <div class="d-flex justify-content-center" :class="{'default-page-paddings': withTitle}">
            <div class="container container-medium article">
                <h1 class="heading black" v-if="withTitle">{{ $t('header_how_does_it_work') }}</h1>
                <div v-if="locale == 'ro'">
                    <div v-if="showBoth == 'both' || showBoth == 'vignette'">
                        <h3 class="special-title"><strong>Rovinieta</strong></h3>
                        <div class="reading">
                            <p>Comandă online rovinieta pe <router-link :to="{name: 'vignette'}">E-rovinieta</router-link></p>
                                <p><strong>Cum poți achiziționa rovinieta online de pe <router-link :to="{name: 'vignette'}">E-rovinieta</router-link>:</strong></p>
                            <ul>
                                <li>
                                    Selectează categoria vehiculului (de ex. Autoturisme, Transport Marfa MTMA &lt;= 3,5t,
                                    Transport Marfa 3,5t &lt; MTMA &lt;= 7,5t etc. Categoria autovehiculului o poți găsi la poziția
                                    J, iar masa tehnică maximă autorizată (MTMA) la poziția F1 din talonul/certificatul de
                                    inmatriculare)
                                </li>
                                <li>
                                    Selectează perioada de valabilitate a rovinietei, data de la care intră în vigoare rovinieta,
                                    numărul de înmatriculare, seria de șasiu (deși nu este obligatorie la rovinietele de 1 zi și
                                    7 zile, recomandăm trecerea seriei de sasiu pentru corectitudinea datelor), țara de
                                    înmatriculare și, opțional, motivul categoriei inferioare (se completează doar în cazul în
                                    care categoria selectată este inferioară celei din evidențele RAR).
                                </li>
                                <li>
                                    Adaugă în coș rovinieta. Poți adăuga în coș și alte roviniete, prin apăsarea butonului ”mai cumpără”
                                </li>
                                <li>
                                    La pasul următor poți intra în contul tău și să alegi datele de facturare deja salvate sau
                                    poți plasa comanda fără cont completând datele solicitate în formular. Dacă ești
                                    persoană juridică trebuie să ne lași doar adresa de email și numărul de telefon, iar la
                                    CUI să treci codul unic de înregistrare/codul de identificare fiscal și să apeși pe butonul
                                    VERIFICA, iar datele firmei tale vor fi precompletate automat
                                </li>
                                <li>
                                    La pasul următor poți alege modalitatea de plată – online cu card bancar prin
                                    intermediul procesatorului securizat de carduri sau prin bancă cu ordin de plată.
                                </li>
                            </ul>
                            <p>
                                După confirmarea plății se emit rovinietele și primești prin e-mail factura și datele rovinietelor și
                                prin SMS datele rovinietelor emise.
                            </p>
                            <p>Comenzile, rovinietele emise si facturile se vor putea accesa oricând în contul personal de pe site</p>
                            <p><router-link class="custom-link" :to="{name: 'questions'}">Apasati aici</router-link> pentru a afla cum se pot corecta rovinietele deja emise.</p>
                            <p><b>ATENȚIE!</b></p>
                            <p>NU se pot emite roviniete cu data de valabilitate anterioară datei de emitere.</p>
                            <p>NU se pot emite roviniete decât cu cel mult 30 zile anterior datei de început a valabilității.</p>
                            <p>
                                Rovinietele se emit numai dupa confirmarea plății sumei în contul bancar al UNTRR (în câteva
                                minute în cazul plății online cu cardul bancar finalizate sau în aceeași zi sau în ziua următoare
                                în cazul plății prin ordin de plată).
                            </p>
                            <p>
                                DUPA TRIMITEREA UNEI COMENZI NU CIRCULATI PE DRUMURILE
                                NAȚIONALE/AUTOSTRĂZI ÎNAINTE DE A PRIMI CONFIRMAREA EMITERII ROVINIETEI,
                                PRIN SMS ȘI/SAU PE E-MAIL!
                            </p>
                        </div>
                    </div>
                    <div v-if="showBoth == 'both' || showBoth == 'toll'">
                        <h3 class="special-title"><strong>Taxa pod Fetesti</strong></h3>
                        <div class="reading">
                            <p>Comandă online trecerile de pod (peaj) pentru Fetești-Cernavodă pe <router-link :to="{name: 'toll'}">Taxa-pod-fetesti</router-link></p>
                            <p><strong>Cum poți achiziționa trecerile de pod (peaj) online de pe <router-link :to="{name: 'toll'}">Taxa-pod-fetesti</router-link>:</strong></p>
                            <ul>
                                <li>
                                    Selectează categoria vehiculului (de ex. Categoria 1 - Autoturisme, Transport Marfa
                                    MTMA &lt;= 3,5t, Categoria 2 - Transport Marfa 3,5t &lt; MTMA &lt;= 7,5t/microbuze etc.
                                    Categoria autovehiculului o poți găsi la poziția J, iar masa tehnică maximă autorizată
                                    (MTMA) la poziția F1 din talonul/certificatul de inmatriculare)
                                </li>
                                <li>
                                    Selectează numărul de treceri (1, 2 sau 20 de treceri), numărul de înmatriculare, seria
                                    de șasiu, țara de înmatriculare și, opțional, motivul categoriei inferioare (se completează
                                    doar în cazul în care categoria selectată este inferioară celei din evidențele RAR).
                                </li>
                                <li>
                                    Adaugă în coș peajul. Poți adăuga în coș și alte peaje, prin apăsarea butonului ”mai cumpără”
                                </li>
                                <li>
                                    La pasul următor poți intra în contul tău și să alegi datele de facturare deja salvate sau
                                    poți plasa comanda fără cont completând datele solicitate în formular. Dacă ești
                                    persoană juridică trebuie să ne lași doar adresa de email și numărul de telefon, iar la
                                    CUI să treci codul unic de înregistrare/codul de identificare fiscal și să apeși pe butonul
                                    VERIFICA, iar datele firmei tale vor fi precompletate automat
                                </li>
                                <li>
                                    La pasul următor poți alege modalitatea de plată – online cu card bancar prin
                                    intermediul procesatorului securizat de carduri sau prin bancă cu ordin de plată.
                                </li>
                            </ul>
                            <p>
                                După confirmarea plății se emit trecerile de pod (peajele) și primești prin e-mail factura și datele
                                rovinietelor și prin SMS datele peajelor emise.<br/><br/>
                                Comenzile, peajele emise si facturile se vor putea accesa oricând în contul personal de pe site.<br/></br>
                                De reținut! Odată achiziționată, o trecere de pod (peaj) este valabilă 1 an de zile. Peajele se
                                poat achita înainte de utilizarea podurilor sau până la ora 24:00 a zilei următoare trecerii.
                            </p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="showBoth == 'both' || showBoth == 'vignette'">
                        <h3 class="special-title"><strong>Vignette</strong></h3>
                        <div class="reading">
                            <p>Order Romanian vignette (rovinieta) online on <router-link :to="{name: 'vignette'}">E-rovinieta</router-link></p>
                            <p>How can you buy Romanian vignette (rovinieta) online from <router-link :to="{name: 'vignette'}">E-rovinieta</router-link>:</p>
                            <ul>
                                <li>
                                    - Select the vehicle category (e.g. Cars, Freight Transport MTMA &lt;= 3,5t, Freight Transport 3,5t &lt;MTMA
                                    &lt;= 7,5t etc. You can find the vehicle category at position J and the maximum authorized technical mass
                                    (MTMA) at position F1 in the registration certificate)
                                </li>
                                <li>
                                    - Select the validity period of the vignette (rovinieta), the date from which will enter into force, the
                                    registration number, the chassis series (although it is not mandatory for 1-day and 7-day, we
                                    recommend passing the chassis series for the correctness of the data), the country of registration and,
                                    optionally, the reason for the lower category (to be completed only if the selected category is lower
                                    than in the RAR records).
                                </li>
                                <li>
                                    - Add the vignette (rovinieta) to the basket. You can add other vignettes to the cart, by pressing the &quot;buy
                                    more&quot; button
                                </li>
                                <li>
                                    - In the next step you can enter your account and choose the billing data already saved or you can place
                                    the order without an account by filling in the required data in the form.
                                </li>
                                <li>
                                    - In the next step you can choose the payment method - online by bank card, through the secure card
                                    processor, or by bank payment order.
                                </li>
                            </ul>
                            <p><b>ATTENTION</b></p>
                            <p>You cannot issue a vignette (rovinieta) with a validity date prior to the date of issue.</p>
                            <p>Vignettes (roviniete) may NOT be issued until 30 days before the start date of validity.</p>
                            <p>Vignettes (roviniete) are issued only after confirmation of payment of the amount in the bank account of UNTRR (in a few minutes in case of online payment or on the same day or the next day in case of payment by bank order).</p>
                            <p>AFTER SENDING AN ORDER, DO NOT TRAVEL ON NATIONAL ROADS / HIGHWAYS BEFORE RECEIVING THE CONFIRMATION OF THE ISSUE OF THE VIGNETTE (ROVINIETA), BY SMS AND / OR BY E-MAIL!</p>
                        </div>
                    </div>
                    <div v-if="showBoth == 'both' || showBoth == 'toll'">
                        <h3 class="special-title"><strong>Fetesti Toll</strong></h3>
                        <div class="reading">
                            <p>Order online bridge tolling for Fetești-Cernavoda on <router-link :to="{name: 'toll'}">Taxa-pod-fetesti</router-link></p>
                            <p><strong>How to buy bridge tolling online from <router-link :to="{name: 'toll'}">Taxa-pod-fetesti</router-link>:</strong></p>
                            <ul>
                                <li>Select the vehicle category (e.g. Category 1 - Cars, Freight Transport MTMA &lt;= 3,5t, Category 2 - Freight Transport 3,5t &lt;MTMA &lt;= 7,5t etc. You can find the vehicle category at position J and the maximum authorized technical mass (MTMA) at position F1 in the registration certificate)</li>
                                <li>Select the number of passings (1, 2 or 20), the plate number, the chassis series, the country of registration and, optionally, the reason for the lower category (to be completed only if the selected category is lower than in the RAR records).</li>
                                <li>Add the bridge toll to the basket. You can add other tolls to the cart, by pressing the "buy more" button</li>
                                <li>In the next step you can enter your account and choose the billing data already saved or you can place the order without an account by filling in the required data in the form.</li>
                                <li>In the next step you can choose the payment method - online by bank card, through the secure card processor, or by bank payment order.</li>
                            </ul>
                            <p>After confirming the payment, the bridge tolls are issued and you will receive by e-mail the invoice and the toll data and by SMS the toll data issued.</p>
                            <p>Orders, tolls issued and invoices can be accessed at any time in the personal account on the website.</p>
                            <p>Attention! Once purchased, a bridge toll is valid for 1 year. Tolls can be paid before using the bridges or until 24:00 the day after crossing.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Heading from './snippets/Heading.vue'
import { mapState } from 'vuex'

export default {
    name: 'HowItWorks',
    props: {
        withTitle: {
            type: Boolean,
            default: true
        },
        showBoth: {
            type: String,
            default: 'both'
        }
    },
    components: {
        Heading
    },
    data() {
        return {
            url: process.env.VUE_APP_URL
        }
    },
    computed: {
        ...mapState('language', [
            'locale'
        ])
    }
}
</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #59af54;

.special-title {
    padding-top: 40px;
    padding-bottom: 40px;
    font-size: 20px;
}
// .router-link-exact-active {
//     border-bottom-color: $green !important;
//     border-bottom-width: 3px !important;
//     border-bottom-style: solid !important;
//     margin-bottom: -2px !important;
//     color: $green !important;
//     p {
//         color: $green !important;
//     }
// }

.checkout-tab-button {
    padding: 13px 0px 13px 0px;
    display: block;
    p {
        font-size: 14px;
        color: $lightgrey;
        margin-bottom: 0px;
    }
}

@media only screen and (max-width: 768px) {
    .special-title {
        font-size: 18px;
        padding-top: 25px;
        padding-bottom: 25px;
    }
}


</style>
